require('./informativeItem.scss');

const PropTypes = require('prop-types');

const React = require('react');

const InformativeItem = props => {
    const {title, primaryText, secondaryText} = props;
    //TODO: Add toUpperCaseLogin
    return (
        <section className="informative-item">
            <div className="informative-item__title">
                {title}
            </div>
            <div className="informative-item__primary-text">
                {primaryText}
            </div>
            <div className="informative-item__secondary-text">
                {secondaryText}
            </div>
        </section>
    );
};

InformativeItem.propTypes = {
    title: PropTypes.string.isRequired,
    primaryText: PropTypes.string.isRequired,
    secondaryText: PropTypes.string,
    isUppercaseTitle: PropTypes.bool
};

InformativeItem.defaultProps = {
    title: '',
    primaryText: '',
    secondaryText: '',
    isUppercaseTitle: false
};

module.exports = InformativeItem;